/* eslint-disable no-new */
import { KeenSliderNavigation } from "./keen-slider-navigation-plugin";
import { KeenSliderKeyboardNavigation } from "./keen-slider-keyboard-navigation-plugin";
import KeenSlider from "keen-slider";
// todo: legacy code - rewrite to use global slider

const TOGGLE_OVERFLOW_CLASS = "toggle-flavours-slider--static";

/** Collections toggle sliders only: turns off drag/loop when slides fit without horizontal overflow. */
function toggleFlavoursOverflowPlugin(slider) {
  function measureOverflow() {
    if (!slider.container.offsetParent) {
      return null;
    }

    const slides = slider.slides;
    if (!slides.length) {
      return false;
    }

    const so = slider.options.slides;
    const spacing =
      typeof so === "object" &&
      so !== null &&
      typeof so.spacing === "number"
        ? so.spacing
        : 0;

    const totalWidth = slides.reduce((sum, el, i) => {
      return (
        sum +
        el.getBoundingClientRect().width +
        (i < slides.length - 1 ? spacing : 0)
      );
    }, 0);

    return totalWidth > slider.size + 0.5;
  }

  function syncFlavoursOverflow() {
    const overflow = measureOverflow();
    if (overflow === null) {
      return;
    }

    slider.container.classList.toggle(TOGGLE_OVERFLOW_CLASS, !overflow);

    const patch = overflow
      ? { drag: true, loop: true, rubberband: true }
      : { drag: false, loop: false, rubberband: false };

    if (
      slider.options.drag === patch.drag &&
      slider.options.loop === patch.loop &&
      slider.options.rubberband === patch.rubberband
    ) {
      return;
    }

    slider.update(patch);
  }

  slider.on("created", syncFlavoursOverflow);
  slider.on("updated", syncFlavoursOverflow);
  slider.on("optionsChanged", syncFlavoursOverflow);
  slider.syncFlavoursOverflow = syncFlavoursOverflow;
}

export const buildFlavorsSlider = () => {
  const newOptions = {
    mode: "free-snap",
    loop: true,
    slides: {
      origin: "center",
      perView: "auto",
      spacing: 12,
    },
    breakpoints: {
      "(min-width: 768px)": {
        mode: "free-snap",
        loop: true,
        slides: {
          origin: "center",
          perView: "auto",
          spacing: 20,
        },
      },
    },
  };

  const defaultOptions = {
    mode: "free-snap",
    loop: true,
    slides: {
      origin: "center",
      perView: "auto",
      spacing: 50,
    },
  };

  document.querySelectorAll("[js-flavours-slider]").forEach(function (sliderEl) {
    const newSlider = sliderEl.getAttribute("data-collection");

    const plugins = [
      KeenSliderNavigation({ arrows: true, dots: false }),
      KeenSliderKeyboardNavigation,
    ];
    if (sliderEl.classList.contains("toggle-flavours-slider")) {
      plugins.push(toggleFlavoursOverflowPlugin);
    }

    const instance = new KeenSlider(
      sliderEl,
      newSlider ? newOptions : defaultOptions,
      plugins
    );
    sliderEl._keenFlavoursSlider = instance;
  });
};
